import React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';

type TooltipProps = {
    content: React.ReactNode;
    children: React.ReactElement;
    side?: 'top' | 'right' | 'bottom' | 'left';
    align?: 'start' | 'center' | 'end';
    delayDuration?: number;
    className?: string;
};

/**
 * ツールチップコンポーネント
 * @param content ツールチップの内容
 * @param children ツールチップを適用する要素
 * @param side ツールチップの位置
 * @param align ツールチップの揃え方
 * @param delayDuration ツールチップの表示遅延時間
 * @param className ツールチップのクラス名
 * @returns
 */
const Tooltip: React.FC<TooltipProps> = ({
    content,
    children,
    side = 'top',
    align = 'center',
    delayDuration = 200,
    className,
}) => {
    return (
        <RadixTooltip.Provider delayDuration={delayDuration}>
            <RadixTooltip.Root>
                <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
                <RadixTooltip.Portal>
                    <RadixTooltip.Content
                        side={side}
                        align={align}
                        sideOffset={6}
                        className={
                            className ||
                            'z-[60] select-none rounded-md bg-gray-800 text-white text-xs px-2 py-1 shadow-lg border border-black/10'
                        }
                    >
                        {content}
                        <RadixTooltip.Arrow className="fill-gray-800" />
                    </RadixTooltip.Content>
                </RadixTooltip.Portal>
            </RadixTooltip.Root>
        </RadixTooltip.Provider>
    );
};

export default Tooltip;
